import { render, staticRenderFns } from "./printList.vue?vue&type=template&id=0ccfd51e&"
import script from "./printList.vue?vue&type=script&lang=js&"
export * from "./printList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports